import React from 'react';
import {Radio} from 'semantic-ui-react';
import {injectIntl} from 'react-intl';

import AutoSaveField from './abstract/AutoSaveField.jsx';
import {isNoU} from "utils/DBUtils";

class AutoSaveRadio extends React.Component {

  getValueForOption(event, data, option) {
    return data.checked ? option.value : "";
  }

  get options() {
    return this.props.options || [];
  }

  get multiOptions() {
      let options = this.options.map((item, index) => ({
          text: item.text || (item.textKey ? this.props.intl.formatMessage({id: item.textKey}) : ""),
          value: item.value,
          key: this.props.fieldKey
      }));
      return {
          options: options,
          currentValue: this.props.defaultValue,
          colCount: this.props.colCount || 1
      }
  }

  get hasValidDefaultValue() {
    return !isNoU(this.props.defaultValue);
  }

  render() {
    return (
      <AutoSaveField {...this.props}
                     control={Radio}
                     name={`radio-${this.props.name}`}
                     multiOptions={this.multiOptions}
                     fieldLabel={this.props.fieldLabel}
                     helpHeader={this.props.helpHeader}
                     defaultValue={this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue}
                     usingLinkedValue={!isNoU(this.props.linkedValue) && !this.hasValidDefaultValue}
                     helpContent={this.props.helpContent}
                     getValueFromOnChange={(event, data, option) => this.getValueForOption(event, data, option)}

      />
    );
  }
}

export default injectIntl(AutoSaveRadio);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveRadio.jsx